<template>
  <load
    v-if="loading"
    class="my-3 py-3"
    mode="table"
    :message="`Buscando por <span class='highlightText'>${search}</span>`"
  />
  <div v-else>
    <div class="card bg-light">
      <div class="card-body">
        <p>
          Digite o nome do usuário que deseja associar a este atendimento e
          aguarde a pesquisa.
        </p>
        <form @submit.prevent="submitSearch" ref="search">
          <b-input-group class="mt-3">
            <b-input-group-prepend>
              <b-input-group-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input
              v-model="search"
              placeholder="Digite um Nome de Usuário, Responsável Familiar, Filiação 1 ou CPF"
              @input="submitSearch"
            ></b-form-input>
            <b-input-group-append v-if="showResultSearch">
              <b-button
                @click="
                  showResultSearch = false;
                  search = null;
                "
                variant="danger"
                type="submit"
                data-style="zoom-in"
                class="btn-submit"
              >
                Limpar Busca
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </form>
      </div>
    </div>
    <div class="row">
      <div
        class="col-md-12 mt-4"
        v-if="!showResultSearch && relacionados.length"
      >
        <h4 class="h4">Usuários relacionados</h4>
        <ListUsuariosRelacionados
          :atendimentoId="atendimentoId"
          :relacionados="relacionados"
          @remove="getUsuariosRelacionados()"
        ></ListUsuariosRelacionados>
      </div>

      <div class="col-12 card" v-if="showResultSearch">
        <!-- <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5895ff"
            /> -->
        <div class="card-body p-0 m-0">
          <b-table
            :fields="[
              {
                key: 'nome_completo',
                label: $t('Nome'),
              },
              {
                key: 'data_nascimento',
                label: $t('Nascimento'),
              },
              {
                key: 'mae',
                label: $t('Filiação 1'),
              },
              {
                key: 'estado_cadastral',
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right',
                thStyle: { width: '95px', minWidth: '95px' },
              },
            ]"
            :items="familiasList"
            striped
            hover
            show-empty
            small
            outlined
            stacked="md"
            table-class="mb-3"
            :responsive="true"
          >
            <template v-slot:cell(nome_completo)="data">
              <strong>
                <span
                  v-html="
                    $options.filters.highlight(
                      data.item.nome_completo,
                      search.trim()
                    )
                  "
                ></span>
              </strong>
            </template>
            <template v-slot:cell(cpf)="data">
              <strong>
                <span
                  v-if="data.item.documento"
                  v-html="
                    $options.filters.highlight(
                      data.item.documento.cpf,
                      search.trim()
                    )
                  "
                ></span
              ></strong>
            </template>
            <template v-slot:cell(data_nascimento)="data">
              <strong> {{ data.item.data_nascimento }}</strong>
            </template>

            <template v-slot:cell(mae)="data">
              <strong>
                <span
                  v-html="
                    $options.filters.highlight(data.item.mae, search.trim())
                  "
                ></span
              ></strong>
            </template>
            <template v-slot:cell(estado_cadastral)="data">
              <span class="small" v-html="data.item.estado_cadastral"></span>
            </template>
            <template v-slot:cell()="data">
              <b-button
                :title="$t('Relacionar')"
                size="sm"
                type="button"
                v-b-tooltip.hover
                variant="success"
                @click.prevent="
                  usuarioId = data.item.id;
                  usuarioNome = data.item.nome_completo;
                  setUsuarioAtendimento();
                "
              >
                Adicionar
              </b-button>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">{{ $t("No records found") }}</h3>
              </div>
            </template>
          </b-table>

          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="form-group d-inline-flex mb-0">
                <select
                  class="form-control"
                  style="width: 70px"
                  v-model="perPage"
                  v-on:change="getFamilias(page, perPage)"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
              </div>
              <div class="d-inline-flex ml-2">
                <b-pagination
                  :per-page="perPage"
                  :total-rows="pagination.total"
                  @change="changePage"
                  v-model="page"
                />
              </div>
            </div>
            <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
              <div class="float-lg-right">
                {{ $t("Showing page") }}
                {{ pagination.currentPage }}
                de
                {{ pagination.totalPages }}
                {{ $t("pages in") }}
                {{ pagination.total }}
                {{ $t("records") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="bv-modal-add" centered hide-footer>
      <template #modal-title> Relacionar Usuário: {{ usuarioNome }} </template>
      <form @submit.prevent="submitRelacionar">
        <div class="row">
          <form-select
            v-model="relacionar.parentesco_rf"
            grid="12"
            label="Parentesco com usuário atendido"
            :itens="$root.arrays.posicao_familiar"
            :required="true"
          />

          <form-textarea
            v-model="relacionar.descricao"
            grid="12"
            label="Deseja adicionar alguma observação?"
            :required="true"
          />
        </div>
        <div class="float-right mt-3">
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import ListUsuariosRelacionados from "./includes/ListUsuariosRelacionados.vue";

export default {
  name: "RelacionarUsuarios",
  props: ["atendimentoId", "paginationFamilia", "submitsearch"],
  data() {
    return {
      page: 1,
      perPage: 4,
      familiasList: {},
      loading: false,
      showResultSearch: false,
      search: "",
      filtroFamiliares: "",
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      usuarioId: null,
      usuarioNome: null,
      relacionar: {
        parentesco_rf: null,
        descricao: "",
        atendimento_id: null,
        usuario_id: null,
      },
      relacionados: [],
    };
  },
  mounted() {
    this.getUsuariosRelacionados();
  },
  methods: {
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getFamilias(this.page, this.perPage);
      }
    },
    submitSearch: function submitSearch() {
      this.showResultSearch = false;
      if (this.search != "" && this.search.length > 3) {
        clearTimeout(submitSearch.timeout);
        submitSearch.timeout = setTimeout(() => {
          this.showResultSearch = true;
          this.getFamilias();
          // this.$root.$emit("submitsearch", this.search);
        }, 1000);
      }
    },
    getFamilias(page = 1, perPage = 10) {
      this.loading = true;
      axios
        .get("api/dashboard/buscar/usuariosrelacionar/atendimento", {
          params: {
            page: page,
            search: this.search,
            perPage: perPage,
            // filtroFamiliares: this.filtroFamiliares
          },
        })
        .then((response) => {
          this.familiasList = response.data.dados;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getFamilias(page);
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getUsuariosRelacionados() {
      this.loading = true;
      axios
        .get(
          "api/dashboard/atendimento/" +
            this.atendimentoId +
            "/usuarios/relacionados"
        )
        .then((response) => {
          this.relacionados = response.data;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    setUsuarioAtendimento() {
      this.$bvModal.show("bv-modal-add");
    },
    submitRelacionar() {
      this.showResultSearch = false;
      this.loading = true;
      this.relacionar.atendimento_id = this.atendimentoId;
      this.relacionar.usuario_id = this.usuarioId;
      axios
        .post(
          `api/dashboard/atendimento/${this.atendimentoId}/usuarios/relacionados`,
          this.relacionar
        )
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.message,
          });
          this.loading = false;

          this.relacionar = {
            parentesco_rf: null,
            descricao: "",
            atendimento_id: null,
            usuario_id: null,
          };
          this.getUsuariosRelacionados();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: { ListUsuariosRelacionados },
};
</script>

<style>
.highlightText {
  background: yellow;
}
</style>
